(function () {
  'use strict';

  if (window.__GRINDERPUNCH_CART_DRAWER_JS_LOADED__) {
    if (typeof window.refreshCartDrawerUI === 'function') {
      window.refreshCartDrawerUI({ reloadRecommendations: false });
    }
    return;
  }

  window.__GRINDERPUNCH_CART_DRAWER_JS_LOADED__ = true;

function formatCartDrawerAmount(cents, decimals = 2, thousands = ',', decimal = '.') {
    const value = (Number(cents) / 100).toFixed(decimals);
    const parts = value.split('.');
    const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? dollars + decimal + parts[1] : dollars;
  }

  function formatCartDrawerMoneyPattern(cents, moneyFormat) {
    if (!moneyFormat) return '';

    const placeholder = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!placeholder) return '';

    let value = '';
    switch (placeholder[1]) {
      case 'amount':
        value = formatCartDrawerAmount(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatCartDrawerAmount(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatCartDrawerAmount(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatCartDrawerAmount(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatCartDrawerAmount(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatCartDrawerAmount(cents, 0, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatCartDrawerAmount(cents, 2, "'", '.');
        break;
      default:
        value = formatCartDrawerAmount(cents, 2);
    }

    return moneyFormat.replace(placeholder[0], value);
  }

  function normalizeCartDrawerCurrencyText(value, currencyCode) {
    if (currencyCode === 'INR') {
      return value.replace(/^₹\s?/, 'Rs. ');
    }

    return value;
  }

  function formatCartDrawerShippingMoney(cents, row) {
    const centsValue = Math.round(Number(cents) || 0);
    const currencyCode =
      row?.dataset.currencyCode || window.Shopify?.currency?.active || window.Shopify?.currency?.currency || 'USD';
    const moneyFormat = row?.dataset.moneyFormat;

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
      return normalizeCartDrawerCurrencyText(window.Shopify.formatMoney(centsValue, moneyFormat), currencyCode);
    }

    const formattedByPattern = formatCartDrawerMoneyPattern(centsValue, moneyFormat);
    if (formattedByPattern) {
      return normalizeCartDrawerCurrencyText(formattedByPattern, currencyCode);
    }

    if (window.Intl && currencyCode) {
      try {
        const intlValue = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode,
        }).format(centsValue / 100);

        return normalizeCartDrawerCurrencyText(intlValue, currencyCode);
      } catch (error) {
        // Fall back to a plain decimal if a browser does not recognize the active currency code.
      }
    }

    return (centsValue / 100).toFixed(2);
  }

  window.updateCartDrawerBogoProgress = function () {
    const container = document.querySelector('#shopify-section-cart-drawer [data-bogo-progress-bar-container]');
    if (!container) return;

    const textEl = container.querySelector('[data-bogo-progress-text]');
    const fillEl = container.querySelector('[data-bogo-progress-fill]');

    const step1Text = container.dataset.step1Text || "ADD A 2ND PAIR FOR ONLY $19.99";
    const step2Text = container.dataset.step2Text || "ADD A 3RD PAIR, GET 3 FOR $69";
    const step3Text = container.dataset.step3Text || "YOU UNLOCKED 3 PAIRS FOR $69 · 4TH PAIR ONLY $15";
    const step4Text = container.dataset.step4Text || "EXTRA PAIRS ONLY $15 EACH";

    const cartItems = document.querySelectorAll('#shopify-section-cart-drawer .cart_drawer_item');
    const useCollections = (container.dataset.bogoCollections || '').trim() !== '';
    let totalGlasses = 0;

    cartItems.forEach(item => {
      const qtyEl = item.querySelector('.cart_drawer_item_quantity');
      const qty = parseInt(qtyEl?.textContent?.trim() || '1', 10);
      const safeQty = Number.isFinite(qty) && qty > 0 ? qty : 1;

      // Collection mode: only items from selected collections count
      if (useCollections) {
        if (item.dataset.bogoMatch === 'true') totalGlasses += safeQty;
        return;
      }

      // Default mode (no collection selected): original behavior
      const title = item.querySelector('.cart_drawer_item_title')?.textContent || '';
      if (!title.includes('MYSTERY') && !title.includes('FLEXCASE') && !title.includes('FLAG')) {
        totalGlasses += safeQty;
      }
    });

    let headingText = step1Text;
    let fillWidth = "25%";

    if (totalGlasses >= 4) {
      headingText = step4Text;
      fillWidth = "100%";
    } else if (totalGlasses === 3) {
      headingText = step3Text;
      fillWidth = "75%";    
    } else if (totalGlasses === 2) {
      headingText = step2Text;
      fillWidth = "50%";
    }

    if (textEl) textEl.textContent = headingText;
    if (fillEl) fillEl.style.width = fillWidth;
  };

  window.formatBogoBadgesOnly = function () {
    const badges = document.querySelectorAll('#shopify-section-cart-drawer .cart_drawer_item_discount_badge, #shopify-section-cart-drawer .csapp_discount_badge');
    badges.forEach(badge => {
      const text = badge.textContent.trim().toUpperCase();
      if (text.includes('BUY 1 GET 2') || text.includes('BUY 1  | GET 2')) {
        badge.textContent = 'BOGO FREE';
        badge.classList.add('bogo_badge');
      }
    });
  };

  window.updateCartDrawerShippingDisplay = function () {
    window.updateCartDrawerBogoProgress();
    window.formatBogoBadgesOnly();

    const shippingRow = document.querySelector('#shopify-section-cart-drawer [data-cart-shipping-row]');
    const shippingBar = document.querySelector('#shopify-section-cart-drawer [data-shipping-bar]');
    
    const activeRate = parseFloat(window.Shopify?.currency?.rate);
    const currencyRate = Number.isFinite(activeRate) && activeRate > 0 ? activeRate : 1;

    // 1. Update Free Shipping Progress Bar at the top if present
    if (shippingBar) {
      const thresholdUsd = parseFloat(shippingBar.dataset.freeShippingThresholdUsd) || 0;
      const cartTotalCents = parseFloat(shippingBar.dataset.cartTotal) || 0;
      const thresholdActiveCents = thresholdUsd * currencyRate * 100;
      
      const messageEl = shippingBar.querySelector('[data-shipping-message]');
      const progressBarEl = shippingBar.querySelector('[data-shipping-progress-bar]');
      
      if (thresholdActiveCents > 0) {
        const remainingCents = thresholdActiveCents - cartTotalCents;
        const progressPct = Math.min(100, Math.max(0, (cartTotalCents / thresholdActiveCents) * 100));
        
        if (progressBarEl) {
          progressBarEl.style.width = progressPct + '%';
        }
        
        if (messageEl) {
          if (remainingCents > 0) {
            const formattedRemaining = formatCartDrawerShippingMoney(remainingCents, shippingBar);
            messageEl.innerHTML = `You're <strong>${formattedRemaining}</strong> away from <strong>Free Shipping!</strong>`;
          } else {
            messageEl.innerHTML = 'You unlocked <strong>Free Shipping!</strong>';
          }
        }
      }
    }

    // 2. Update Shipping Row in the cart footer summary if present
    if (shippingRow) {
      const shippingPrice = shippingRow.querySelector('[data-cart-shipping-price]');
      if (shippingPrice) {
        const thresholdUsd = parseFloat(shippingRow.dataset.freeShippingThresholdUsd) || 0;
        const paidShippingUsd = parseFloat(shippingRow.dataset.paidShippingUsd) || 0;
        const cartTotalCents = parseFloat(shippingRow.dataset.cartTotal) || 0;
        const freeLabel = shippingRow.dataset.freeLabel || 'FREE';
        const thresholdActiveCents = thresholdUsd * currencyRate * 100;

        if (thresholdActiveCents <= 0 || cartTotalCents >= thresholdActiveCents) {
          shippingPrice.textContent = freeLabel;
        } else {
          shippingPrice.textContent = formatCartDrawerShippingMoney(paidShippingUsd * currencyRate * 100, shippingRow);
        }
      }
    }
  };

  window.updateCartDrawerShippingDisplay();
  document.addEventListener('DOMContentLoaded', window.updateCartDrawerShippingDisplay);
  document.addEventListener('shopify:section:load', window.updateCartDrawerShippingDisplay);

  // ── Review slider ─────────────────────────────────────────────────────────
  function cleanStaleSwiperMarkup(element) {
    if (!element || (element.swiper && !element.swiper.destroyed)) return;

    element.classList.remove(
      'swiper-initialized',
      'swiper-horizontal',
      'swiper-vertical',
      'swiper-backface-hidden',
      'swiper-autoheight',
      'swiper-watch-progress',
      'swiper-lock'
    );

    const wrapper = element.querySelector('.swiper-wrapper');
    if (wrapper) {
      wrapper.removeAttribute('style');
    }

    element.querySelectorAll('.swiper-slide').forEach(function (slide) {
      slide.classList.remove(
        'swiper-slide-active',
        'swiper-slide-next',
        'swiper-slide-prev',
        'swiper-slide-visible',
        'swiper-slide-fully-visible'
      );
      slide.removeAttribute('style');
    });
  }

  function destroySwiperElement(element) {
    if (!element) return;

    if (element.swiper && !element.swiper.destroyed) {
      element.swiper.destroy(true, true);
    }

    cleanStaleSwiperMarkup(element);
  }

  function initCartReviewSwipers(root = document) {
    if (typeof window.Swiper !== 'function') return;

    root.querySelectorAll('.cart-reviews .swiper').forEach(function (element) {
      if (!element.querySelector('.swiper-slide')) return;

      if (element.swiper && !element.swiper.destroyed) {
        element.swiper.updateSize();
        element.swiper.updateSlides();
        element.swiper.updateProgress();
        element.swiper.update();
        return;
      }

      cleanStaleSwiperMarkup(element);

      new window.Swiper(element, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 60,
        speed: 1000,
        direction: 'horizontal',
        autoplay: {
          delay: 9000,
          disableOnInteraction: false,
        },
      });
    });
  }

  // Delegated listener keeps working after cart HTML is replaced.
  $(document)
    .off('click.gpCartDrawerLineItem', '.update_line_item')
    .on('click.gpCartDrawerLineItem', '.update_line_item', function () {
      var key = $(this).closest('.line_item').attr('key');
      var quantity = $(this).attr('q');

      if (typeof window.watchForCartDrawerUpdate === 'function') {
        window.watchForCartDrawerUpdate();
      }

      if (typeof update_line_item === 'function') {
        update_line_item(key, quantity);
      }
    });

  // ── Cart-based recommendations ─────────────────────────────────────────────

  function cdProductId(id) {
    return String(id);
  }

  function cdFormatMoney(cents) {
    const activeRate = parseFloat(window.Shopify?.currency?.rate);
    const rate = Number.isFinite(activeRate) && activeRate > 0 ? activeRate : 1;
    const converted = Math.round(cents);
    const currencyCode = window.Shopify?.currency?.active || 'USD';
    const moneyFormat = window.Shopify?.money_format;

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
      let formatted = window.Shopify.formatMoney(converted, moneyFormat);
      if (currencyCode === 'INR') formatted = formatted.replace(/^₹\s?/, 'Rs. ');
      return formatted;
    }
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(converted / 100);
    } catch (e) {
      return (converted / 100).toFixed(2);
    }
  }

  function cdShowRecsSkeletons(list, count) {
    list.innerHTML = Array.from({ length: count })
      .map(
        () => `
      <div class="cd_recs_skeleton">
        <div class="cd_recs_skeleton_img"></div>
        <div class="cd_recs_skeleton_lines">
          <div class="cd_recs_skeleton_line"></div>
          <div class="cd_recs_skeleton_line"></div>
        </div>
      </div>
    `
      )
      .join('');
  }

  let cartRecommendationsAbortController = null;
  let cartRecommendationsRequestId = 0;

  function cdEscapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  async function loadCartRecommendations() {
    const section = document.getElementById('cd_recommendations_section');
    if (!section) return;

    const list = section.querySelector('#cd_recommendations_list');
    if (!list) return;

    const recommendationSwiper = section.querySelector('.cart_drawer_upsells_swiper');

    if (cartRecommendationsAbortController) {
      cartRecommendationsAbortController.abort();
    }

    cartRecommendationsAbortController = new AbortController();
    const signal = cartRecommendationsAbortController.signal;
    const requestId = ++cartRecommendationsRequestId;

    const hasExistingItems = list.querySelectorAll('.cart_drawer_upsell').length > 0;
    if (!hasExistingItems) {
      destroySwiperElement(recommendationSwiper);
      list.innerHTML = '';
      section.style.display = 'none';
    }

    let productIds;
    try {
      productIds = JSON.parse(section.dataset.cartProductIds || '[]').map(cdProductId);
    } catch (error) {
      return;
    }

    if (!productIds.length) {
      destroySwiperElement(recommendationSwiper);
      list.innerHTML = '';
      section.style.display = 'none';
      return;
    }

    const maxRecs = parseInt(section.dataset.maxRecs, 10) || 8;
    const hideCartItems = section.dataset.hideCartItems !== 'false';
    const discountPercent = parseInt(section.dataset.discountPercent, 10) || 0;
    const productCount = productIds.length;
    const base = Math.floor(maxRecs / productCount);
    const remainder = maxRecs % productCount;
    const quotas = productIds.map(function (_, index) {
      return base + (index < remainder ? 1 : 0);
    });

    if (!hasExistingItems) {
      section.style.display = '';
      cdShowRecsSkeletons(list, Math.min(maxRecs, 3));
    }

    const excludeIds = hideCartItems ? new Set(productIds) : new Set();

    try {
      const fetchResults = await Promise.all(
        productIds.map(function (id, index) {
          const limit = Math.max(1, quotas[index] * 3);
          return fetch(
            `/recommendations/products.json?product_id=${encodeURIComponent(id)}&limit=${limit}&intent=related`,
            { signal: signal }
          )
            .then(function (response) {
              if (!response.ok) throw new Error('Recommendation request failed');
              return response.json();
            })
            .then(function (data) {
              return { products: data.products || [], quota: quotas[index] };
            })
            .catch(function (error) {
              if (error.name === 'AbortError') throw error;
              return { products: [], quota: quotas[index] };
            });
        })
      );

      if (
        signal.aborted ||
        requestId !== cartRecommendationsRequestId ||
        !section.isConnected ||
        !list.isConnected
      ) {
        return;
      }

      const shownIds = new Set();
      const recommendations = [];

      fetchResults.forEach(function (result) {
        let count = 0;

        result.products.forEach(function (product) {
          if (count >= result.quota) return;

          const productId = cdProductId(product.id);
          const firstVariant = product.variants && product.variants[0];

          if (excludeIds.has(productId)) return;
          if (shownIds.has(productId)) return;
          if (!firstVariant || !firstVariant.available) return;

          shownIds.add(productId);
          recommendations.push({ product: product, variant: firstVariant });
          count += 1;
        });
      });

      if (!recommendations.length) {
        list.innerHTML = '';
        section.style.display = 'none';
        return;
      }

      const addLabel = section.dataset.addLabel || 'ADD TO CART';

      const newHtml = recommendations
        .map(function (item) {
          const product = item.product;
          const variant = item.variant;
          const price = Number(product.price) || 0;
          let displayPrice = price;
          let comparePrice = Number(product.compare_at_price) || 0;

          if (discountPercent > 0) {
            displayPrice = Math.round((price * (100 - discountPercent)) / 100);
            comparePrice = price;
          }

          const hasSaving = comparePrice > displayPrice;
          const rawImage = product.featured_image
            ? typeof product.featured_image === 'string'
              ? product.featured_image
              : product.featured_image.src
            : product.images && product.images[0]
            ? product.images[0].src
            : '';

          const imageUrl = rawImage
            ? rawImage.replace(/(\.[^.?]+)(\?|$)/, '_180x$1$2')
            : '';

          const title = cdEscapeHtml(product.title);
          const vendor = cdEscapeHtml(product.vendor || product.type || '');
          const handle = cdEscapeHtml(product.handle || '');
          const dataId = cdEscapeHtml(String(product.handle || '').replace(/-/g, '_'));
          const variantId = cdEscapeHtml(variant.id);
          const buttonLabel = cdEscapeHtml(addLabel);

          return `
            <div class="cart_drawer_upsell swiper-slide" data-handle="${handle}" data-id="${dataId}">
              ${discountPercent > 0 ? `<span class="cart_drawer_upsell_offer_badge">-${discountPercent}% OFF</span>` : ''}
              <div class="cart_drawer_upsell_title">${title}</div>
              ${
                imageUrl
                  ? `<div class="cart_drawer_upsell_image_wrapper"><img src="${cdEscapeHtml(imageUrl)}" alt="${title}" class="cart_drawer_upsell_image" width="86" height="54" loading="lazy"></div>`
                  : ''
              }
              <div class="cart_drawer_upsell_details">
                <div class="cart_drawer_upsell_price_row">
                  <div class="cart_drawer_upsell_price">
                    <div class="cd_upsell_final_price${hasSaving ? ' with-savings' : ''}">
                      ${cdFormatMoney(displayPrice)}
                    </div>
                    ${hasSaving ? `<div class="cd_upsell_compare_price">${cdFormatMoney(comparePrice)}</div>` : ''}
                  </div>
                  <button
                    type="button"
                    class="cart_drawer_upsell_circle_add cart_drawer_upsell_add"
                    onclick="addUpsellProduct(this)"
                    data-variant-id="${variantId}"
                    aria-label="${buttonLabel}"
                  >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.18709e-05 5.30399H5.30405V-1.20401e-05H8.63205V5.30399H13.9101V8.63199H8.63205V13.936H5.30405V8.63199H5.18709e-05V5.30399Z" fill="white"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>`;
        })
        .join('');

      destroySwiperElement(recommendationSwiper);
      list.innerHTML = newHtml;
      section.style.display = list.querySelector('.cart_drawer_upsell') ? '' : 'none';

      requestAnimationFrame(function () {
        if (typeof window.initCartDrawerSwipers === 'function') {
          window.initCartDrawerSwipers(section);
        }
      });
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Unable to load cart recommendations:', error);
      }
    }
  }

  window.loadCartRecommendations = loadCartRecommendations;

  // ── Safe cart-drawer Swiper manager ──────────────────────────────────────
  const CART_STANDARD_SWIPER_SELECTOR =
    '.cart_drawer_upsells--complete-set .cart_drawer_upsells_swiper, ' +
    '.cart_drawer_upsells--top-picks .cart_drawer_upsells_swiper';

  const CART_RECOMMENDED_SWIPER_SELECTOR =
    '.cart_drawer_upsells--recommended .cart_drawer_upsells_swiper';

  function getElementsFromRoot(root, selector) {
    const elements = [];

    if (root instanceof Element && root.matches(selector)) {
      elements.push(root);
    }

    if (root && typeof root.querySelectorAll === 'function') {
      root.querySelectorAll(selector).forEach(function (element) {
        if (!elements.includes(element)) elements.push(element);
      });
    }

    return elements;
  }

  function updateSwiperElement(element) {
    if (!element || !element.swiper || element.swiper.destroyed) return false;

    element.swiper.updateSize();
    element.swiper.updateSlides();
    element.swiper.updateProgress();
    element.swiper.update();
    return true;
  }

  function initStandardCartSwiper(element) {
    if (!element || !element.isConnected) return;
    if (!element.querySelector('.swiper-slide')) return;

    if (updateSwiperElement(element)) return;

    cleanStaleSwiperMarkup(element);

    new window.Swiper(element, {
      slidesPerView: 'auto',
      spaceBetween: 4,
      freeMode: true,
      freeModeMomentum: true,
      freeModeSticky: false,
      allowTouchMove: true,
      simulateTouch: true,
      grabCursor: true,
      watchOverflow: true,
      resistance: true,
      resistanceRatio: 0.85,
      loop: false,
      // Do not enable Swiper MutationObserver options here.
      // Cart updates are refreshed manually to avoid an infinite loop.
      observer: false,
      observeParents: false,
      observeSlideChildren: false,
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 4,
          allowTouchMove: true,
          simulateTouch: true,
        },
      },
    });
  }

  function initRecommendedCartSwiper(element) {
    if (!element || !element.isConnected) return;

    if (window.innerWidth >= 768) {
      destroySwiperElement(element);
      return;
    }

    if (!element.querySelector('.swiper-slide')) return;
    if (updateSwiperElement(element)) return;

    cleanStaleSwiperMarkup(element);

    new window.Swiper(element, {
      slidesPerView: 'auto',
      spaceBetween: 4,
      freeMode: true,
      watchOverflow: true,
      allowTouchMove: true,
      simulateTouch: true,
      loop: false,
      observer: false,
      observeParents: false,
      observeSlideChildren: false,
    });
  }

  function initCartDrawerSwipers(root = document) {
    if (typeof window.Swiper !== 'function') return;

    getElementsFromRoot(root, CART_STANDARD_SWIPER_SELECTOR).forEach(initStandardCartSwiper);
    getElementsFromRoot(root, CART_RECOMMENDED_SWIPER_SELECTOR).forEach(initRecommendedCartSwiper);
    initCartReviewSwipers(root);
  }

  function destroyCartDrawerSwipers(root = document) {
    const selector =
      CART_STANDARD_SWIPER_SELECTOR + ', ' +
      CART_RECOMMENDED_SWIPER_SELECTOR + ', ' +
      '.cart-reviews .swiper';

    getElementsFromRoot(root, selector).forEach(destroySwiperElement);
  }

  let cartDrawerRefreshTimer = null;

  function refreshCartDrawerUI(options = {}) {
    const reloadRecommendations = options.reloadRecommendations === true;

    clearTimeout(cartDrawerRefreshTimer);
    cartDrawerRefreshTimer = setTimeout(function () {
      const drawer = document.getElementById('shopify-section-cart-drawer');
      if (!drawer) return;

      if (typeof window.updateCartDrawerShippingDisplay === 'function') {
        window.updateCartDrawerShippingDisplay();
      }

      if (typeof window.updateCartDrawerCheckoutStatus === 'function') {
        window.updateCartDrawerCheckoutStatus();
      }

      requestAnimationFrame(function () {
        initCartDrawerSwipers(drawer);

        if (reloadRecommendations && typeof window.loadCartRecommendations === 'function') {
          window.loadCartRecommendations();
        }
      });
    }, 80);
  }

  window.initCartDrawerSwipers = initCartDrawerSwipers;
  window.destroyCartDrawerSwipers = destroyCartDrawerSwipers;
  window.refreshCartDrawerUI = refreshCartDrawerUI;

  // One-shot observer: starts only when a cart action happens, disconnects before
  // Swiper initializes, and therefore cannot create an observer/Swiper loop.
  let cartUpdateObserver = null;
  let cartUpdateObserverTimeout = null;
  let cartUpdateObserverDebounce = null;

  function stopCartUpdateWatcher() {
    if (cartUpdateObserver) {
      cartUpdateObserver.disconnect();
      cartUpdateObserver = null;
    }

    clearTimeout(cartUpdateObserverTimeout);
    clearTimeout(cartUpdateObserverDebounce);
    cartUpdateObserverTimeout = null;
    cartUpdateObserverDebounce = null;
  }

  function watchForCartDrawerUpdate() {
    stopCartUpdateWatcher();

    const drawer = document.getElementById('shopify-section-cart-drawer');
    const observerTarget = drawer && drawer.parentNode ? drawer.parentNode : document.body;
    if (!observerTarget) return;

    cartUpdateObserver = new MutationObserver(function (mutations) {
      const hasRelevantCartChange = mutations.some(function (mutation) {
        const targetElement =
          mutation.target.nodeType === Node.ELEMENT_NODE
            ? mutation.target
            : mutation.target.parentElement;

        if (
          targetElement &&
          (targetElement.id === 'shopify-section-cart-drawer' ||
            targetElement.closest('#shopify-section-cart-drawer'))
        ) {
          return true;
        }

        const changedNodes = [
          ...Array.from(mutation.addedNodes || []),
          ...Array.from(mutation.removedNodes || []),
        ];

        return changedNodes.some(function (node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;

          return (
            node.id === 'shopify-section-cart-drawer' ||
            (typeof node.matches === 'function' && node.matches('#shopify-section-cart-drawer')) ||
            (typeof node.querySelector === 'function' &&
              Boolean(node.querySelector('#shopify-section-cart-drawer')))
          );
        });
      });

      if (!hasRelevantCartChange) return;

      clearTimeout(cartUpdateObserverDebounce);
      cartUpdateObserverDebounce = setTimeout(function () {
        stopCartUpdateWatcher();
        refreshCartDrawerUI({ reloadRecommendations: true });
      }, 100);
    });

    cartUpdateObserver.observe(observerTarget, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    cartUpdateObserverTimeout = setTimeout(function () {
      stopCartUpdateWatcher();
      refreshCartDrawerUI({ reloadRecommendations: false });
    }, 5000);
  }

  window.watchForCartDrawerUpdate = watchForCartDrawerUpdate;

  let cartDrawerResizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(cartDrawerResizeTimer);
    cartDrawerResizeTimer = setTimeout(function () {
      refreshCartDrawerUI({ reloadRecommendations: false });
    }, 150);
  });

  ['cart:updated', 'cart-drawer:updated', 'cart:refresh', 'ajaxProduct:added'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      refreshCartDrawerUI({ reloadRecommendations: true });
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target;
    if (
      section &&
      (section.id === 'shopify-section-cart-drawer' ||
        section.querySelector?.('#shopify-section-cart-drawer'))
    ) {
      refreshCartDrawerUI({ reloadRecommendations: false });
    }
  });

  // Start the one-shot watcher before common cart buttons run their own click code.
  document.addEventListener(
    'click',
    function (event) {
      const cartAction = event.target.closest(
        '#shopify-section-cart-drawer .cart_item_quantity_update, ' +
          '#shopify-section-cart-drawer .cart_drawer_item_remove, ' +
          '#shopify-section-cart-drawer .cart_drawer_upsell_add, ' +
          '#shopify-section-cart-drawer .mystery_add_to_cart_btn, ' +
          '.update_line_item, ' +
          'form[action*="/cart/add"] button[type="submit"], ' +
          'form[action*="/cart/add"] input[type="submit"], ' +
          '[data-add-to-cart], ' +
          '.product-form__submit, ' +
          '.quick-add__submit'
      );

      if (cartAction) {
        watchForCartDrawerUpdate();
      }
    },
    true
  );

  // ── End safe cart-drawer Swiper manager ──────────────────────────────────

  // ── Cart drawer open/close ────────────────────────────────────────────────
  let focusTrapHandler = null;

  window.open_slider_cart = function () {
    const drawer = document.getElementById('shopify-section-cart-drawer');
    if (!drawer) return;

    if (typeof close_all_layers === 'function') {
      close_all_layers('cart');
    }

    if (typeof show_overlay === 'function') {
      show_overlay();
    }

    drawer.classList.add('slided');
    drawer.removeAttribute('aria-hidden');
    drawer.inert = false;

    // Hide the back-to-top icon while the cart drawer is open.
    document.querySelectorAll('.grinder-to-top').forEach(function (icon) {
      icon.style.display = 'none';
    });

    requestAnimationFrame(function () {
      refreshCartDrawerUI({ reloadRecommendations: false });
      loadCartRecommendations();
    });

    setTimeout(function () {
      const closeButton = drawer.querySelector(
        '.cart_drawer_header_close, .cart_drawer_close_button'
      );
      if (closeButton) closeButton.focus();
    }, 100);

    if (focusTrapHandler) {
      document.removeEventListener('keydown', focusTrapHandler);
    }

    focusTrapHandler = function (event) {
      if (event.key === 'Escape') {
        window.close_slider_cart();
        return;
      }

      if (event.key !== 'Tab') return;

      const currentDrawer = document.getElementById('shopify-section-cart-drawer');
      if (!currentDrawer) return;

      const focusableElements = currentDrawer.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );

      if (!focusableElements.length) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    };

    document.addEventListener('keydown', focusTrapHandler);
  };

  window.close_slider_cart = function () {
    const drawer = document.getElementById('shopify-section-cart-drawer');

    if (typeof hide_overlay === 'function') {
      hide_overlay();
    }

    if (drawer) {
      drawer.classList.remove('slided');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
    }

    // Show the back-to-top icon again after the cart drawer closes.
    document.querySelectorAll('.grinder-to-top').forEach(function (icon) {
      icon.style.display = '';
    });

    if (focusTrapHandler) {
      document.removeEventListener('keydown', focusTrapHandler);
      focusTrapHandler = null;
    }

    const cartButton = document.getElementById('cart-icon-link-header');
    if (cartButton) cartButton.focus();
  };

  document.addEventListener('DOMContentLoaded', function () {
    function updateCheckoutStatus() {
      const agreeCheckbox = document.getElementById('cart_drawer_agree_terms');
      const checkoutButtons = document.querySelectorAll('.cart_drawer_checkout_button');
      const isChecked = agreeCheckbox ? agreeCheckbox.checked : true;

      checkoutButtons.forEach(function (button) {
        if (isChecked) {
          button.classList.remove('disabled');
          button.removeAttribute('aria-disabled');
        } else {
          button.classList.add('disabled');
          button.setAttribute('aria-disabled', 'true');
        }
      });

      const checkmark = document.querySelector('.cart_drawer_checkmark_svg');
      if (checkmark) {
        checkmark.style.display = isChecked ? 'block' : 'none';
      }
    }

    window.updateCartDrawerCheckoutStatus = updateCheckoutStatus;

    document.addEventListener('click', function (event) {
      const checkoutButton = event.target.closest('.cart_drawer_checkout_button');
      if (!checkoutButton) return;

      const agreeCheckbox = document.getElementById('cart_drawer_agree_terms');

      if (agreeCheckbox && !agreeCheckbox.checked) {
        event.preventDefault();
        event.stopPropagation();

        if (typeof Swal !== 'undefined') {
          Swal.fire({
            title: 'Agreement Required',
            text: 'Please agree to the Terms & Conditions and Privacy Policy to proceed.',
            icon: 'warning',
            confirmButtonColor: '#1a1a1a',
          });
        } else {
          alert('Please agree to the Terms & Conditions and Privacy Policy to proceed with checkout.');
        }
      }
    });

    document.addEventListener('change', function (event) {
      if (event.target && event.target.id === 'cart_drawer_agree_terms') {
        updateCheckoutStatus();
      }
    });

    $(document)
      .off('click.gpMysteryCategory', '.mystery_category_btn')
      .on('click.gpMysteryCategory', '.mystery_category_btn', function () {
        $('.mystery_category_btn').removeClass('active');
        $(this).addClass('active');
        checkMysteryPairStatus();
      });

    $(document)
      .off('click.gpMysteryShape', '.mystery_shape_card')
      .on('click.gpMysteryShape', '.mystery_shape_card', function () {
        $('.mystery_shape_card').removeClass('active');
        $(this).addClass('active');
        checkMysteryPairStatus();
      });

    function checkMysteryPairStatus() {
      const activeCategory = $('.mystery_category_btn.active').data('category');
      const activeShape = $('.mystery_shape_card.active').data('shape');
      const addButton = $('.mystery_add_to_cart_btn');

      if (activeCategory && activeShape) {
        addButton.removeClass('disabled').removeAttr('disabled');
      } else {
        addButton.addClass('disabled').attr('disabled', 'true');
      }
    }

    $(document)
      .off('click.gpMysteryAdd', '.mystery_add_to_cart_btn:not(.disabled)')
      .on('click.gpMysteryAdd', '.mystery_add_to_cart_btn:not(.disabled)', function () {
        const button = $(this);
        const variantId = button.attr('data-variant-id');
        const activeCategory = $('.mystery_category_btn.active').data('category');
        const activeShape = $('.mystery_shape_card.active').data('shape');
        const originalHtml = button.html();

        if (!variantId || !activeCategory || !activeShape) return;
        if (window.isCartDrawerUpdating) return;

        window.isCartDrawerUpdating = true;
        if (typeof show_cart_drawer_loading === 'function') {
          show_cart_drawer_loading();
        }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js?_t=' + new Date().getTime(),
          contentType: 'application/json',
          data: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  Category: activeCategory,
                  Shape: activeShape,
                  _atc_source: 'mystery-pair',
                },
              },
            ],
            sections: typeof getCartDrawerSectionId === 'function' ? getCartDrawerSectionId() : 'cart-drawer',
            sections_url: window.location.pathname
          }),
          dataType: 'json',
          cache: false
        })
          .done(function (data) {
            try {
              $('.mystery_category_btn').removeClass('active');
              $('.mystery_shape_card').removeClass('active');
              checkMysteryPairStatus();
              button.html(originalHtml);

              if (data.sections && typeof replaceCartDrawerContentFromSections === 'function') {
                replaceCartDrawerContentFromSections(data.sections);
                refreshCartDrawerUI({ reloadRecommendations: true });
              } else if (typeof update_cart_content === 'function') {
                update_cart_content();
              }

              if (typeof hide_cart_drawer_loading === 'function') {
                hide_cart_drawer_loading();
              }

              if (typeof update_header_icon === 'function') {
                update_header_icon();
              }
            } catch (e) {
              console.error('Mystery pair done error:', e);
              if (typeof update_cart_content === 'function') {
                update_cart_content();
              }
            } finally {
              window.isCartDrawerUpdating = false;
              if (typeof hide_cart_drawer_loading === 'function') {
                hide_cart_drawer_loading();
              }
            }
          })
          .fail(function (error) {
            console.error('Error adding mystery pair:', error);
            button
              .removeClass('disabled')
              .removeAttr('disabled')
              .html(originalHtml);
            window.isCartDrawerUpdating = false;
          });
      });

    updateCheckoutStatus();
    initCartReviewSwipers(document);
  });

  window.toggleCustomSelect = function (btn) {
    const customSelect = btn.closest('[data-custom-select]');
    if (!customSelect) return;

    const isOpen = customSelect.classList.contains('is-open');

    document.querySelectorAll('[data-custom-select].is-open').forEach(function (el) {
      if (el !== customSelect) {
        el.classList.remove('is-open');
        el.querySelector('.cart_drawer_custom_select_trigger')?.setAttribute('aria-expanded', 'false');
      }
    });

    if (isOpen) {
      customSelect.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    } else {
      customSelect.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  };

  window.selectCustomOption = function (optionEl) {
    const customSelect = optionEl.closest('[data-custom-select]');
    if (!customSelect) return;

    const val = optionEl.getAttribute('data-value');
    const labelEl = customSelect.querySelector('.custom_select_label');
    const hiddenSelect = customSelect.querySelector('.cart_drawer_upsell_mystery_select');

    if (labelEl) labelEl.textContent = val;

    customSelect.querySelectorAll('.cart_drawer_custom_select_option').forEach(function (opt) {
      const checkEl = opt.querySelector('.custom_select_check');
      if (opt === optionEl) {
        opt.classList.add('is-selected');
        if (checkEl) checkEl.textContent = '✓';
      } else {
        opt.classList.remove('is-selected');
        if (checkEl) checkEl.textContent = '';
      }
    });

    if (hiddenSelect) {
      hiddenSelect.value = val;
      hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const upsellContainer = customSelect.closest('.cart_drawer_upsell');
    if (upsellContainer) {
      upsellContainer.setAttribute('data-selected-option', val);
    }

    customSelect.classList.remove('is-open');
    customSelect.querySelector('.cart_drawer_custom_select_trigger')?.setAttribute('aria-expanded', 'false');
  };

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-custom-select]')) {
      document.querySelectorAll('[data-custom-select].is-open').forEach(function (el) {
        el.classList.remove('is-open');
        el.querySelector('.cart_drawer_custom_select_trigger')?.setAttribute('aria-expanded', 'false');
      });
    }
  });

})();